import { render, staticRenderFns } from "./DesignView.vue?vue&type=template&id=20b8f95f&scoped=true"
import script from "./DesignView.vue?vue&type=script&lang=js"
export * from "./DesignView.vue?vue&type=script&lang=js"
import style0 from "./DesignView.vue?vue&type=style&index=0&id=20b8f95f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b8f95f",
  null
  
)

export default component.exports